import { VaultedCard, VaultedCardResponse } from '@core/models';
import {
	CheckoutAssociatedCardInput,
	CheckoutAssociatedCardRequest,
} from '../interfaces/checkout-credit-card.interface';

export function createAssociatedCardRequest(input: CheckoutAssociatedCardInput): CheckoutAssociatedCardRequest {
	if (!input.customerData) {
		throw new Error('Customer data is required');
	}

	if (!input.token) {
		throw new Error('A valid payment token is required');
	}

	return {
		customerData: input.customerData,
		token: input.token,
		customerMerchId: input.customerMerchId ?? null,
	};
}

export function requireVaultedCardsClientId(clientId: string | undefined): string {
	if (!clientId) {
		throw new Error('Client ID is required');
	}

	return clientId;
}

export function getFirstVaultedCard(response: VaultedCardResponse): VaultedCard | null {
	return response.data?.[0] ?? null;
}

export function getDefaultVaultedCard(cards: VaultedCard[]): VaultedCard | null {
	return cards.find((card) => card.default) ?? cards[0] ?? null;
}
